import styled, { css } from 'styled-components';

const getTriangle = () => {
  return css`
    &::after {
      content: '';
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 6px 4px 0 4px;
      border-color: rgb(58, 57, 73) transparent transparent transparent;
      z-index: 1;
      position: absolute;
      bottom: -6px;
      left: 50%;
      transform: translate(-50%, 0);
    }
  `;
};

const getPosition = ({ left, top }) => {
  return `
    position: absolute;
    top: ${top}px;
    left: ${left}px;
    transform: translate(-50%, calc(-100% - 12px));
  `;
};
const StyledDotTooltip = styled.div`
  border-radius: ${(props) => props.theme.border_radius.standard};
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  text-align: left;
  width: max-content;
  max-width: 250px;
  white-space: pre-line;
  font-size: ${(props) => props.theme.size.small};
  line-height: 18px;
  color: ${(props) => props.theme.colors.light};
  background-color: ${(props) => props.theme.colors.dark_light};
  box-shadow: ${(props) => props.theme.shadow.position}
    ${(props) => props.theme.shadow.color};
  padding: ${(props) => props.theme.spacing.small};
  ${(props) => getTriangle()};
  ${(props) => getPosition(props)};
  z-index: ${(props) => props.theme.zindex.small};
`;

const StyledDotsChartWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  background-color: ${(props) => props.theme.colors.light};
`;

export { StyledDotTooltip, StyledDotsChartWrapper };
